import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ theme }) => ({
  background: theme.color.overlayDarkFaint,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  opacity: 1,
  position: 'absolute',
  width: '100%',
});

const MiniControlContainer = React.forwardRef(({ onMouseEnter, onMouseLeave, children }, ref) => {
  const { css } = useFela();

  return (
    <div ref={ref} className={css(rules)} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {children}
    </div>
  );
});

MiniControlContainer.propTypes = {
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  children: PropTypes.node,
};

export default React.memo(MiniControlContainer);
